module.exports = __webpack_public_path__ + "static/revolution-2b7b9f5e844b83100b95276ded993549.jpg";